export const CONQUER_FRANQUIAS_SCHOOL_UNIT_ID_PROD = '001N400000ILFZaIAP';
export const CONQUER_FRANQUIAS_STATE_PROD = 'PR';
export const CONQUER_FRANQUIAS_CITY_PROD = 'Curitiba';

export const CONQUER_FRANQUIAS_SCHOOL_UNIT_ID_DEV = '001HZ00000MIuM8YAL';
export const CONQUER_FRANQUIAS_STATE_DEV = 'PR';
export const CONQUER_FRANQUIAS_CITY_DEV = 'Curitiba';
